module.exports = __webpack_public_path__ + "img/icon-events.a2d18b38.svg";